import { Button } from '@cottage/design-system/internal-tooling/ui'

type ConcurrencyDialogProps = {
  onReload: () => void
  onReloadKeepDraft: () => void
  onCancel: () => void
  saving?: boolean
}

export default function ConcurrencyDialog({
  onReload,
  onReloadKeepDraft,
  onCancel,
  saving = false,
}: ConcurrencyDialogProps) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={onCancel}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="concurrency-title"
        className="relative w-full max-w-lg rounded-xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="concurrency-title" className="text-sm font-semibold text-gray-900">
          Someone saved this case since you loaded it
        </h3>
        <p className="mt-3 text-sm text-gray-600">
          Reload to discard your edits and see their changes, or reload the server copy and keep your
          draft to save on top.
        </p>
        <div className="mt-5 flex flex-wrap justify-end gap-2">
          <Button variant="outline" size="md" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="outline" size="md" onClick={onReload} disabled={saving}>
            Reload
          </Button>
          <Button variant="primary" size="md" onClick={onReloadKeepDraft} disabled={saving}>
            Reload and keep my draft
          </Button>
        </div>
      </div>
    </div>
  )
}
